import { Heading3 } from '@casavo/base-ui'
import cn from 'classnames'
import { useField, useFormikContext } from 'formik'
import useTranslation from 'next-translate/useTranslation'
import { useEffect, useState } from 'react'
import * as Yup from 'yup'

import { SearchInput } from '@/components/_base/SearchInput'
import GeoFilterComponent from '@/components/Modal/Types/GeoFilter/Body'
import { Translated } from '@/components/Translated'
import { useCities } from '@/context/Cities'
import { sprinkles } from '@/design-lib/style-theme/sprinkles.css'
import { GeoFilter } from '@/types/filter'
import { GTMEventCategory } from '@/utils/tracking/eventCategory'

import {
  suggestedPropertyFlowStepPaddingTop,
  suggestedPropertyFlowStepContent,
  buyerInterestPreferredZone,
} from './styles.css'

export const PreferredZonesIntialValue = () => ({ preferredZones: [] })

export const PreferredZonesValidation = () =>
  Yup.object().shape({
    preferredZones: Yup.array().min(1, 'Select at least one city or zone').required(),
  })

export const PreferredZones: React.FC = () => {
  const { t } = useTranslation()
  const cities = useCities()
  const [search, setSearch] = useState<string>('')
  const [field, _, helpers] = useField<GeoFilter[]>('preferredZones')
  const { value: activeFilters } = field
  const { setValue: setActiveFilters } = helpers
  const { validateForm } = useFormikContext()

  useEffect(() => {
    validateForm()
  }, [])

  return (
    <main className={suggestedPropertyFlowStepPaddingTop}>
      <div
        className={cn(suggestedPropertyFlowStepContent, sprinkles({ paddingTop: { desktop: '2xl', mobile: 'xl' } }))}
      >
        <Heading3 className={sprinkles({ paddingBottom: { desktop: '2xl', mobile: 'xl' } })}>
          <Translated
            i18Key="buyer-interest-flow:Zone_Question"
            values={{ city: cities.router.city.translatedCityName }}
          />
        </Heading3>

        <SearchInput placeholder={t('zones:search-filters')} value={search} onBlur={() => {}} onChange={setSearch} />

        <div className={buyerInterestPreferredZone}>
          <GeoFilterComponent
            activeFilters={activeFilters || []}
            eventCategory={GTMEventCategory.MainSearchFlow}
            hideProvince={true}
            listingCountByZone={undefined}
            search={search}
            setActiveFilters={(handler) => setActiveFilters(handler(activeFilters || []))}
            setSearch={setSearch}
          />
        </div>
      </div>
    </main>
  )
}
